import React, { useState, useEffect, useContext } from 'react'
import { useHistory } from 'react-router-dom'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { CustomerContext } from '../../../contexts/CustomerContext'
import { ShootingSchedule } from '../../../models/_models'
import AppointmentLocationInfo from '../../appointment-location-info'
import AttentionBanner from '../../attention-banner'
import ShootingSchedules from '../../shooting-schedules'
import Button from '../../Button'
import classes from './appointment-selection.module.sass'
import { routes } from '../../../routes'
import DressCodeInfo from '../../dress-code-info'
import ReactSelect from 'react-select';
import Typography from '../../Typography';
import { customStyles } from '../schedule-appointment';
import apptImg from './Choose_Appt_Day_Time.jpg';
import apptImgElem from './Senior_Sample.png';
import axios from 'axios';

const useShootingSchedules = (school, student) => {
  const [shootingSchedules, setShootingSchedules] = useState([])
  const [jobs, setJobs] = useState([]);
  const [schedules, setSchedules] = useState([]);
  const [shootingDates,setShootingDates] = useState([])

  //const baseUrl = process.env.NODE_ENV === 'development' ? 'http://localhost:3000' : 'https://shoobphoto.com'

  const [schoolType, setSchoolType] = useState(null);

  useEffect(() => {
    if (school && school.attributes && school.attributes.schoolTypeId) {
      setSchoolType(school.attributes.schoolTypeId);
    }
  }, [school]);
  useEffect(() => {
    /*const fetchSchedules = async () => {
      const response = await axios.get('/shooting_schedules?filter[in_future]=true&filter[school_id]=' + school.id +',1075&sort=start_time&extra_fields[shooting_schedules]=available_timeslots');
      setSchedules(response.data.data);
    };*/

    const fetchJobs = async () => {
      const grade = parseInt(student?.grade);
      if (grade === 11 || grade === 12)
      {
        const response = await axios.get('/djobs/instudio_seniors2?id=' + school.id);
        setJobs(response.data);
      } else {
        const response = await axios.get('/djobs/instudio2');
        setJobs(response.data);
      }
      
    };

    //fetchSchedules();
    fetchJobs();
  }, [school, student]);

  useEffect(() => {
    if (jobs && jobs.length > 0 ) {
      setShootingDates(jobs.map(job => job.date.split('T')[0]));
      
    }  else {
      setShootingDates([]); // Clear shootingDates if jobs is empty
    }
    
  }, [jobs]);

  useEffect(() => {
    
    ShootingSchedule
    .where({ inFuture: true, schoolId: [school.id, 1075] })
      .order('startTime')
      .all()
      .then((res) => setShootingSchedules(res.data))
  }, [school.id,shootingDates])

  useEffect(() => {
    ShootingSchedule
      .selectExtra(['availableTimeslots'])
      .where({ inFuture: true, schoolId: [school.id, 1075] })
      .order('startTime')
      .all()
      .then((res) => setShootingSchedules(res.data))
  }, [shootingSchedules.length])

  return shootingSchedules.filter(schedule => {
    if (shootingDates.length === 0) return true;
    const scheduleDate = (schedule.shootingDay || '').split('T')[0];
    return shootingDates.includes(scheduleDate);
  })
}

const AppointmentSelection = () => {
  const { customer } = useContext(CustomerContext)
  const history = useHistory()
  const shootingSchedules = useShootingSchedules(customer.currentSchool, customer.currentStudent)
  const [appt, setAppt] = useState()
  const [isApptAtShoob, setIsApptAtShoob] = useState(false)
  const [season, setSeason] = useState({});

  const handleContinue = () => {
    setSeason({ label: 'Senior', value: 'senior' })
    if (!appt) {
      toast('There was an error adding this time slot to your cart. Please refresh and try again.', { type: 'error' })
      return;
    }

    customer.currentOrderPackage.cartId = customer.apptCart.id
    customer.currentOrderPackage.schoolId = isApptAtShoob ? 1075 : customer.currentSchool.id

    customer
      .currentOrderPackage
      .save()
      .then((res) => {
        if (!res) {
          toast('There was an error adding this time slot to your cart. Please refresh and try again.',
            { type: 'error' })
          return;
        }

        customer.currentOrderPackage.appointmentSeason = season.value;
        customer.currentOrderPackage.appointmentTime = appt;

        customer.currentOrderPackage.save().then((apptRes) => {
          if (apptRes) history.push(routes.checkout({ app: true }))
        })
      })
  }

  return (
    <>
      <ToastContainer
        position="bottom-left"
      />
      <AttentionBanner content="Step 2. Choose Your Appointment Time" />
      <div className={classes.container}>
        <p className={classes.portraitTitle}>{`${customer.currentSchool.name} Portraits`}</p>
        <div className={classes.apptCard}>
        
            <img src={apptImgElem} alt="Appointment Image" />
          
          <div className={classes.apptCardContent}>
            
            <ShootingSchedules
              school={customer.currentSchool}
              schedules={shootingSchedules}
              setAppt={setAppt}
              selectedOption={customer.currentOrderPackage.option}
              setIsApptAtShoob={setIsApptAtShoob}
            />
            <Button
              classes={classes.btn}
              size="large"
              variant="primary"
              disabled={!appt }
              onClick={handleContinue}
            >
              Continue
            </Button>
          </div>
        </div>
        <AppointmentLocationInfo school={customer.currentSchool} />
        <DressCodeInfo school={customer.currentSchool} />
      </div>
    </>
  )
}

export default AppointmentSelection
